export type CandleZone = { x: number; y: number; w: number; h: number; rgb: string; a: number };
export type CandleBar = { x: number; w: number; y: number; h: number; a: number; col: string; wt: [number, number]; wb: [number, number] };

export const CANDLES: {
  w: number;
  h: number;
  fade: number;
  zones: CandleZone[];
  levels: { y: number[]; x0: number; dash: number };
  bars: CandleBar[];
} = {
  w: 1080,
  h: 500,
  fade: 0.3,
  zones: [
    { x: 473.5, y: 20, w: 606.5, h: 118, rgb: "77,199,163", a: 0.2 },
    { x: 473.5, y: 138, w: 606.5, h: 44, rgb: "229,72,77", a: 0.22 },
  ],
  levels: { y: [149.5, 391.5], x0: 20, dash: 6.02 },
  bars: [
    { x: 48, w: 16, y: 412, h: 18, a: 0.022, col: "#228e71", wt: [396.71, 15.29], wb: [430, 15.29] },
    { x: 76, w: 16, y: 396, h: 16, a: 0.081, col: "#228e71", wt: [381.72, 14.28], wb: [412, 14.28] },
    { x: 104, w: 16, y: 396, h: 24, a: 0.171, col: "rgba(229,72,77,0.282)", wt: [383.47, 12.53], wb: [420, 12.53] },
    { x: 132, w: 16, y: 404, h: 16, a: 0.282, col: "#228e71", wt: [392.58, 11.42], wb: [420, 11.42] },
    { x: 160, w: 16, y: 376, h: 28, a: 0.407, col: "#228e71", wt: [365.29, 10.71], wb: [404, 10.71] },
    { x: 188, w: 16, y: 352, h: 24, a: 0.537, col: "#228e71", wt: [341.02, 10.98], wb: [376, 10.98] },
    { x: 216, w: 16, y: 352, h: 16, a: 0.666, col: "rgba(229,72,77,0.472)", wt: [339.59, 12.4], wb: [368, 12.4] },
    { x: 244, w: 16, y: 340, h: 28, a: 0.784, col: "#228e71", wt: [330.15, 9.85], wb: [368, 9.85] },
    { x: 272, w: 16, y: 312, h: 28, a: 0.884, col: "#228e71", wt: [305.65, 6.35], wb: [340, 6.35] },
    { x: 300, w: 16, y: 312, h: 22, a: 0.957, col: "rgba(229,72,77,0.614)", wt: [300.16, 11.84], wb: [334, 11.84] },
    { x: 328, w: 16, y: 300, h: 34, a: 0.996, col: "#228e71", wt: [294.69, 5.31], wb: [334, 5.31] },
    { x: 356, w: 16, y: 272, h: 28, a: 1, col: "#228e71", wt: [257.78, 14.22], wb: [300, 14.22] },
    { x: 384, w: 16, y: 250, h: 22, a: 1, col: "#228e71", wt: [235.69, 14.31], wb: [272, 14.31] },
    { x: 412, w: 16, y: 250, h: 22, a: 1, col: "rgba(229,72,77,0.804)", wt: [237.34, 12.66], wb: [272, 12.66] },
    { x: 440, w: 16, y: 240, h: 32, a: 1, col: "#228e71", wt: [233.82, 6.18], wb: [272, 6.18] },
    { x: 468, w: 16, y: 214, h: 26, a: 1, col: "#228e71", wt: [200.61, 13.39], wb: [240, 13.39] },
    { x: 496, w: 16, y: 214, h: 18, a: 1, col: "rgba(229,72,77,0.947)", wt: [199.52, 14.48], wb: [232, 14.48] },
    { x: 524, w: 16, y: 196, h: 36, a: 1, col: "#228e71", wt: [187.19, 8.81], wb: [232, 8.81] },
    { x: 552, w: 16, y: 166, h: 30, a: 1, col: "#228e71", wt: [152.33, 13.67], wb: [196, 13.67] },
    { x: 580, w: 16, y: 166, h: 20, a: 1, col: "#e5484d", wt: [150.64, 15.36], wb: [186, 15.36] },
    { x: 608, w: 16, y: 150, h: 36, a: 1, col: "#228e71", wt: [134.31, 15.69], wb: [186, 15.69] },
    { x: 636, w: 16, y: 134, h: 16, a: 1, col: "#228e71", wt: [125.28, 8.72], wb: [150, 8.72] },
    { x: 664, w: 16, y: 134, h: 18, a: 1, col: "#e5484d", wt: [125.12, 8.88], wb: [152, 8.88] },
    { x: 692, w: 16, y: 124, h: 28, a: 1, col: "#228e71", wt: [114.59, 9.41], wb: [152, 9.41] },
    { x: 720, w: 16, y: 96, h: 28, a: 1, col: "#228e71", wt: [81.86, 14.14], wb: [124, 14.14] },
    { x: 748, w: 16, y: 96, h: 16, a: 1, col: "#e5484d", wt: [85.38, 10.62], wb: [112, 10.62] },
    { x: 776, w: 16, y: 84, h: 28, a: 1, col: "#228e71", wt: [78.46, 5.54], wb: [112, 5.54] },
    { x: 804, w: 16, y: 60, h: 24, a: 1, col: "#228e71", wt: [47.49, 12.51], wb: [84, 12.51] },
    { x: 832, w: 16, y: 44, h: 16, a: 1, col: "#228e71", wt: [29.82, 14.18], wb: [60, 14.18] },
    { x: 860, w: 16, y: 30, h: 14, a: 1, col: "#228e71", wt: [21.29, 8.71], wb: [44, 5.71] },
    { x: 888, w: 16, y: 30, h: 12, a: 1, col: "#e5484d", wt: [20.29, 9.71], wb: [42, 6.71] },
    { x: 916, w: 16, y: 20, h: 22, a: 1, col: "#228e71", wt: [9.29, 10.71], wb: [42, 7.71] },
    { x: 944, w: 16, y: 20, h: 12, a: 1, col: "#e5484d", wt: [8.29, 11.71], wb: [32, 8.71] },
    { x: 972, w: 16, y: 8, h: 24, a: 1, col: "#228e71", wt: [-4.71, 12.71], wb: [32, 9.71] },
    { x: 1000, w: 16, y: 8, h: 14, a: 1, col: "#e5484d", wt: [-0.71, 8.71], wb: [22, 5.71] },
    { x: 1028, w: 16, y: -4, h: 26, a: 1, col: "#228e71", wt: [-13.71, 9.71], wb: [22, 6.71] },
    { x: 1056, w: 16, y: -16, h: 12, a: 1, col: "#228e71", wt: [-26.71, 10.71], wb: [-4, 7.71] },
  ],
};
